import React from 'react';
import { FiPlus } from 'react-icons/fi';
import { Link } from 'react-router-dom';

export default function MarketplaceCard({ item }) {
  const cardStyle = {
    backgroundColor: 'rgba(20, 20, 20, 0.8)',
    borderRadius: '12px',
    padding: '10px',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    transition: 'transform 0.2s, background-color 0.2s',
    cursor: 'pointer',
    border: '1px solid #222',
    textDecoration: 'none',
    color: 'inherit',
    WebkitTapHighlightColor: 'transparent',
    minWidth: 0,
    width: '100%'
  };

  const imageContainerStyle = {
    width: '100%',
    aspectRatio: '4/5',
    maxHeight: '170px',
    backgroundColor: '#111',
    borderRadius: '8px',
    overflow: 'hidden',
    position: 'relative',
  };

  const imageStyle = {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  };

  const infoStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  };

  const titleStyle = {
    fontSize: '16px',
    fontWeight: '700',
    color: '#fff',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  };

  const subtitleStyle = {
    fontSize: '12px',
    color: '#888',
    display: '-webkit-box',
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    wordBreak: 'break-word',
  };

  const priceRowStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: '8px',
  };

  const priceLabelStyle = {
    fontSize: '18px',
    fontWeight: '700',
    color: '#fff',
    display: 'flex',
    flexDirection: 'column',
  };

  const priceChangeStyle = {
    fontSize: '11px',
    fontWeight: '500',
    marginTop: '2px',
  };

  const actionButtonStyle = {
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    border: '1px solid #10b981',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#10b981',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    transition: 'all 0.2s',
  };

  const price_changes = parseFloat(item.nl_value) - parseFloat(item.nl_last_value)
  const isPositive = price_changes >= 0
  const price_change_percent = (price_changes / parseFloat(item.nl_value)) * 100

  return (
    <Link
      to={`/vault/${item.nl_id}`}
      className="marketplace-card-link"
      style={{ ...cardStyle, userSelect: 'none' }}
      draggable={false}
      onDragStart={(e) => e.preventDefault()}
    >
      <div style={imageContainerStyle}>
        <img src={item.nl_image3} alt={item.nl_name} style={imageStyle} draggable={false} onDragStart={(e) => e.preventDefault()} />
      </div>

      <div style={infoStyle}>
        <div style={titleStyle}>{item.nl_name}</div>
        <div style={subtitleStyle} dangerouslySetInnerHTML={{ __html: item.nl_remark || "" }} />
      </div>

      <div style={priceRowStyle}>
        <div style={priceLabelStyle}>
          ${Number(item.nl_value).toLocaleString()}
          {/*<span style={{
            ...priceChangeStyle,
            color: isPositive ? '#10b981' : '#ef4444'
          }}>
            {isPositive ? '▲' : '▼'} ${Math.abs(price_changes).toLocaleString()} ({price_change_percent.toFixed(2)}%)
          </span>*/}
        </div>
      </div>
    </Link>
  );
};
